import React, { useEffect, useRef, useState } from 'react';
import { profile } from '../data/portfolio';
import Icon from './Icon';

export default function Navbar({ route }) {
  const [open, setOpen] = useState(false);
  const toggle = useRef(null);
  const menu = useRef(null);
  useEffect(() => {
    if (!open) return undefined;
    menu.current?.querySelector('a')?.focus();
    const onKey = event => {
      if (event.key === 'Escape') { setOpen(false); toggle.current?.focus(); }
    };
    const onClick = event => {
      if (!menu.current?.contains(event.target) && !toggle.current?.contains(event.target)) setOpen(false);
    };
    document.addEventListener('keydown', onKey);
    document.addEventListener('click', onClick);
    return () => { document.removeEventListener('keydown', onKey); document.removeEventListener('click', onClick); };
  }, [open]);
  return (
    <header className="site-header">
      <div className="header-inner page-shell">
        <a className="brand" href="/" aria-label="Vaibhav Lehra, home" onClick={() => window.scrollTo({ top: 0, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' })}><span className="brand-monogram">v<span>l</span>.</span><span className="brand-name">Vaibhav Lehra<span>Python & systems engineering</span></span></a>
        <button ref={toggle} className="menu-toggle" aria-label={open ? 'Close navigation' : 'Open navigation'} aria-expanded={open} aria-controls="primary-navigation" onClick={() => setOpen(value => !value)}><Icon kind={open ? 'close' : 'menu'} /></button>
        <nav id="primary-navigation" aria-label="Primary navigation" ref={menu} className={`primary-nav ${open ? 'nav-open' : ''}`} onClick={event => { if (event.target.closest('a')) setOpen(false); }}>
          <a className={route.type === 'work' || route.type === 'study' ? 'nav-current' : ''} href="/work/">Work</a>
          <a href="/#about">About</a>
          <a href="/#contact">Contact</a>
          <a className="nav-resume" href={profile.resume} download>Resume <Icon kind="download" /></a>
        </nav>
      </div>
    </header>
  );
}
